import { __decorate, __metadata } from "tslib";
import { DefaultExposeGroupEnum, Fingerprintable, instanceToPlainWithLVS, IsUndefinable } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean } from 'class-validator';
import { typify } from '../../common';
import { ReadLocationSyncStatusDto } from './ReadLocationSyncStatusDto';
let ReadLocationDto = class ReadLocationDto {
    getFingerprint() {
        return {
            location: instanceToPlainWithLVS(this, { groups: [DefaultExposeGroupEnum.PROFILER] }),
        };
    }
};
__decorate([
    ApiProperty({ type: typify(String), example: '77s1gcn7-15bf-4aeg-1331-4eafbbd12921' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.PROFILER] }),
    __metadata("design:type", String)
], ReadLocationDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: typify(String), example: '6Y718PCAWAZBA' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.PROFILER] }),
    __metadata("design:type", String)
], ReadLocationDto.prototype, "externalMerchantId", void 0);
__decorate([
    ApiProperty({ type: typify(String), example: '77s1gcn7-15bf-4aeg-1331-4eafbbd12921' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.PROFILER] }),
    __metadata("design:type", String)
], ReadLocationDto.prototype, "storeId", void 0);
__decorate([
    ApiPropertyOptional({ type: typify(Boolean) }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.PROFILER] }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadLocationDto.prototype, "isCentralLocation", void 0);
__decorate([
    ApiProperty({ type: typify(ReadLocationSyncStatusDto) }),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", ReadLocationSyncStatusDto)
], ReadLocationDto.prototype, "syncStatus", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", Date)
], ReadLocationDto.prototype, "createdAt", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", Date)
], ReadLocationDto.prototype, "updatedAt", void 0);
ReadLocationDto = __decorate([
    Fingerprintable()
], ReadLocationDto);
export { ReadLocationDto };
//# sourceMappingURL=ReadLocationDto.js.map